import { Group } from "@mantine/core"
import { IconSearch } from "@tabler/icons-react"
import { Loader, TextInput } from "@tfg/ui"
import { Dispatch, ReactElement, SetStateAction } from "react"
import { useTranslation } from "react-i18next"

import { filtersValidationType } from "@tfg/types/schemas/products"

import { ProductBrandFilter } from "~/components/ProductBrandFilter"
import { ProductCollectionFilter } from "~/components/ProductCollectionFilter"
import { ProductTypeFilter } from "~/components/ProductTypeFilter"
import { SupplierInfoSelector } from "~/pages/Brand/Products/List/Components/SupplierInfoSelector"

interface Props {
  isFetching: boolean
  setFiltersValue: Dispatch<SetStateAction<filtersValidationType>>
  filtersValue: filtersValidationType
  extraFilters?: ReactElement
}

export const ProductFilters = ({
  isFetching,
  setFiltersValue,
  filtersValue,
  extraFilters,
}: Props) => {
  const { t } = useTranslation("products")

  return (
    <Group>
      <TextInput
        size="xs"
        w={180}
        autoFocus
        placeholder={t("lists.placeholders.searchProduct")}
        leftSection={<IconSearch />}
        value={filtersValue.search}
        onChange={(event) => {
          const value = event.currentTarget.value
          setFiltersValue({
            ...filtersValue,
            search: value === "" ? undefined : value,
          })
        }}
        rightSection={isFetching && <Loader size={16} />}
      />
      <ProductTypeFilter
        filtersValue={filtersValue}
        setFiltersValue={setFiltersValue}
      />
      <SupplierInfoSelector
        filtersValue={filtersValue}
        setFiltersValue={setFiltersValue}
      />
      <ProductCollectionFilter
        filtersValue={filtersValue}
        setFiltersValue={setFiltersValue}
      />
      <ProductBrandFilter
        filtersValue={filtersValue}
        setFiltersValue={setFiltersValue}
      />
      {extraFilters ? extraFilters : null}
    </Group>
  )
}
